export const PageUrlRo = {
  template: {
    url: "/template",
  },
  installment: {
    url: "/installment/installmentoptionmanagement",
  },
  campaign: {
    url: "/campaign/campaignmanagement",
  },
  multiRegionCountries: {
    Romania: 50,
  },
};
